<template>
  <div class="shop-menu" :class="$store.state.theme">
    <vue-easy-lightbox
      :visible="visible"
      :imgs="imgs"
      :index="index"
      @hide="hideLightbox"
    ></vue-easy-lightbox>
    <div class="modal shop-menu-modal">
      <div class="modal-background" @click="closeModal"></div>
      <div v-if="!noMenu" style="z-index: 1000; padding-bottom: 2px">
        <span class="tag is-medium has-text-info">
          Tap menu image to zoom&nbsp;
          <i class="fa fa-search-plus" />
        </span>
      </div>
      <div class="modal-card" :key="z">
        <section class="modal-card-body">
          <div
            v-for="(src, idx) in imgs"
            :key="idx"
            @click="showLightbox(idx)"
            class="pic"
          >
            <img :src="src" v-img-fallback="imgFallback" />
          </div>
          <div v-show="noMenu" class="subtitle">No Menu Photos</div>
        </section>
      </div>
      <div style="z-index: 1000; padding-top: 2px">
        <span
          class="tag is-large is-warning has-text-link has-text-weight-medium"
          @click="goToPromosTab"
        >
          {{ $t("commerce.order-now") }}&nbsp;
          <i class="fa fa-chevron-right" />
        </span>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "ShopMenuModal",
  data() {
    return {
      visible: false,
      index: 0, // default: 0
      z: 0,
      imgFallback: {
        loading: `https://miro.medium.com/max/3796/1*hi7euM223Sr-9PIi1Pk7ng.png`,
        error: `https://miro.medium.com/max/978/1*pUEZd8z__1p-7ICIO1NZFA.png`,
      },
    };
  },
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
    imgs() {
      return this.business.menu_photos;
    },
    noMenu() {
      if (!this.business.menu_photos) return true;
      if (this.business.menu_photos.length === 0) return true;
      return false;
    },
  },
  mounted() {
    EventBus.$on("OPEN_SHOP_MENU", () => {
      //   this.z += 1;
    });
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    goToPromosTab() {
      EventBus.$emit("GO_TO_PROMOS_TAB");
      this.closeModal();
    },
    showLightbox(idx) {
      this.index = idx;
      this.visible = true;
    },
    hideLightbox() {
      this.visible = false;
    },
    // force() {
    //   this.$swal({
    //     title: this.business.id,
    //     text: this.imgs
    //   });
    //   //   this.reloadMenu();
    //   this.z += 1;
    //   console.log("force", this.z);
    // },
    // reloadMenu() {
    //   this.$store
    //     .dispatch("tukPhotos", this.business.id)
    //     .then(res => {
    //       this.business.menu_photos = res.data;
    //       console.log("tukPhotos", res.data);
    //     })
    //     .catch(err => this.apiError(err))
    //     .finally(() => {
    //       // test image if none exists
    //       if (
    //         !this.business.menu_photos ||
    //         this.business.menu_photos.length === 0
    //       ) {
    //         this.business.menu_photos = [
    //           `https://tukapp.s3-ap-southeast-1.amazonaws.com/staging/businesses/test/menu/S__11583542.jpg`,
    //           `https://cafeamazon.sg/wp-content/uploads/2020/01/CafeAmazonMenu_20200110_1a.jpg`,
    //           `https://images.squarespace-cdn.com/content/v1/59c1ec65d7bdcef21f01a3da/1551407058081-EX072X7605XZHVM246CK/ke17ZwdGBToddI8pDm48kE6dlGppik78YmuW8dw6gvF7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z5QHyNOqBUUEtDDsRWrJLTmyh-8_5GJNvrfz4o4yOfLS7GiohPIDzekOHrqsXAr_S_1Hut5y_bRDH8Sx2u5sE9E/FINAL+Grand+Menu+Final+WS-2.jpg?format=1500w`,
    //           `https://justatestnothere`
    //         ];
    //       }
    //       console.log("this.business.menu_photos", this.business.menu_photos);
    //       this.z += 1;
    //     });
    // }
  },
};
</script>

<style scoped>
div.card-content {
  padding: 6px;
  overflow: hidden !important;
}
.modal-card-body {
  padding: 12px;
  max-width: 640px;
}
.dark .modal-card-body {
  background-color: #123;
}
img {
  border-radius: 5px;
  -webkit-filter: drop-shadow(1px 1px 1px #666);
  filter: drop-shadow(1px 1px 1px #666);
}
.modal-card-body::-webkit-scrollbar {
  display: none;
}
.subtitle {
  color: grey;
  font-weight: 550;
  opacity: 0.5;
}
</style>